<template>
  <el-dialog
      title="批量关联厂家直采"
      :visible.sync="visible"
      width="90%"
      top="25px"
      append-to-body
      custom-class="batch-alibaba-connect-dialog"
      :close-on-click-modal="false"
      @closed="onDialogClosed"
      class="custom-el-wrapper"
  >
    <div class="batch-connect-body">
      <div class="batch-connect-left">
        <p class="side-title">已选订单已按商品规格分组</p>
        <div class="sku-scroll auto_scrollbar">
          <div
              v-for="(row, idx) in skuItems"
              :key="row._batchKey"
              class="sku-card"
              :class="{ active: idx === activeIndex }"
              @click="selectSku(idx)"
          >
            <div class="sku-card-img">
              <img v-if="row.product_pic" :src="row.product_pic" alt="" />
            </div>
            <div class="sku-card-main">
              <p class="sku-name">{{ row.product_name || '—' }}</p>
              <p class="sku-spec">规格：{{ row.spec_value || '—' }}</p>
              <p class="sku-meta">商品编码：{{ row.pdd_code || row.pdd_sku_id || '—' }}</p>
              <p class="sku-meta">商品ID：{{ row.goods_id || '—' }}</p>

              <p class="sku-link-row">
								<span
                    class="sku-link-tag"
                    :class="isAlibabaLinked(row) ? 'is-linked' : 'is-pending'"
                >{{ alibabaLinkStatusText(row) }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="batch-connect-right">
        <connectBox ref="goodsConnect" :hide-goods-info="true" @close="onConnectBoxClose" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import connectBox from '../alibaba_goods_connect/connect_box.vue'

export default {
  name: 'BatchAlibabaConnect',
  components: { connectBox },
  data() {
    return {
      visible: false,
      skuItems: [],
      activeIndex: 0,
    }
  },
  methods: {
    /** 与订单列表一致：source_type==2 且 pdd_code 有效（非空、不含「规格失效」） */
    isAlibabaLinked(row) {
      const code = row.pdd_code
      const hasCode =
          code !== undefined && code !== null && String(code).trim() !== ''
      if (!hasCode || String(code).includes('规格失效')) return false
      return Number(row.source_type) === 2
    },
    alibabaLinkStatusText(row) {
      return this.isAlibabaLinked(row) ? '已关联' : '待关联'
    },
    open(rows) {
      this.skuItems = Array.isArray(rows) ? rows.map(this.normalizeRow) : []
      this.activeIndex = 0
      this.visible = true
      this.$nextTick(() => {
        this.loadActiveConnect()
      })
    },
    normalizeRow(row) {
      const skuKey =
          row.sku_id != null && row.sku_id !== ''
              ? String(row.sku_id)
              : `id_${row.id}`
      return { ...row, _batchKey: skuKey }
    },
    selectSku(index) {
      if (index === this.activeIndex || index < 0 || index >= this.skuItems.length) return
      this.activeIndex = index
      this.loadActiveConnect()
    },
    loadActiveConnect() {
      const row = this.skuItems[this.activeIndex]
      if (!row || !this.$refs.goodsConnect) return
      const dd_goods_id = row.goods_id
      if (!dd_goods_id) {
        this.$message({ message: '抖店商品不存在', type: 'error' })
        return
      }
      const shop_id = row.shop_id || (row.dd_shop && row.dd_shop.shop_id) || ''
      const alibaba_sku_id = row.pdd_code || ''
      const dd_sku_id = row.sku_id || 0
      const order_product_id = row.id || 0
      const dd_order_id = row.dd_order_id || ''
      this.$refs.goodsConnect.clean()
      this.$nextTick(() => {
        this.$refs.goodsConnect.init(
            alibaba_sku_id,
            dd_goods_id,
            shop_id,
            dd_sku_id,
            order_product_id,
            dd_order_id
        )
      })
    },
    onConnectBoxClose() {
      this.$emit('refresh')
    },
    /** 订单列表刷新后合并最新 pdd_code 等字段，避免切换 SKU 仍用打开弹窗时的旧数据 */
    syncSkuItemsFromList(list) {
      if (!Array.isArray(list) || !this.skuItems.length) return
      const byId = new Map(list.map((r) => [r.id, r]))
      this.skuItems = this.skuItems.map((row) => {
        const fresh = byId.get(row.id)
        return fresh ? this.normalizeRow({ ...row, ...fresh }) : row
      })
      this.$nextTick(() => {
        this.loadActiveConnect()
      })
    },
    onDialogClosed() {
      this.skuItems = []
      this.activeIndex = 0
      if (this.$refs.goodsConnect) {
        this.$refs.goodsConnect.clean()
      }
    },
  },
}
</script>

<style scoped>
.batch-connect-body {
  display: flex;
  gap: 16px;
  min-height: 72vh;
  max-height: calc(100vh - 120px);
  box-sizing: border-box;
}
.batch-connect-left {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #eee;
  border-radius: 6px;
  overflow: hidden;
  background: #fafafa;
}
.side-title {
  margin: 0;
  padding: 12px 14px;
  font-size: 13px;
  color: #666;
  background: #f0f0f0;
  border-bottom: 1px solid #eee;
}
.sku-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}
.sku-card {
  display: flex;
  gap: 10px;
  padding: 10px;
  margin-bottom: 8px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.sku-card:hover {
  border-color: #ccc;
}
.sku-card.active {
  border-color: var(--red, #f0423f);
  box-shadow: 0 0 0 1px rgba(240, 66, 63, 0.15);
}
.sku-card-img {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  background: #eee;
}
.sku-card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sku-card-main {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 1.45;
}
.sku-link-row {
  margin: 0 0 6px;
}
.sku-link-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1.4;
}
.sku-link-tag.is-linked {
  color: #529b2e;
  background: #f0f9eb;
  border: 1px solid #c2e7b0;
}
.sku-link-tag.is-pending {
  color: #c45656;
  background: #fef0f0;
  border: 1px solid #fbc4c4;
}
.sku-name {
  margin: 0 0 4px;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.sku-spec,
.sku-meta {
  margin: 0 0 2px;
  color: #888;
  word-break: break-all;
}
.batch-connect-right {
  flex: 1;
  min-width: 0;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 8px 0;
  background: #fff;
}
</style>

<style>
.batch-alibaba-connect-dialog {
  box-sizing: border-box;
}
.batch-alibaba-connect-dialog .el-dialog__header {
  padding: 14px 20px;
  border-bottom: 1px solid #eee;
}
.batch-alibaba-connect-dialog .el-dialog__body {
  padding: 12px 16px 16px;
  max-height: calc(100vh - 54px);
  overflow: hidden;
  box-sizing: border-box;
}
</style>
